import { Grid } from '@mui/material'
import React from 'react'
import "../../../../assets/styles/componentStyles/chatbotStyles/chats.module.scss";
import globalStyles from "../../../../assets/styles/global.module.scss";
import styles from "../../../../assets/styles/componentStyles/chatbotStyles/integrations.module.scss";
import { Outlet } from 'react-router-dom';

interface chatsProps {
    mainSection?: boolean
}
export default function IntegrationWrapper(props: chatsProps) {
    return (
        <Grid item xl={12} lg={12} md={12} sm={12} xs={12} className={`${globalStyles.fullwidth} ${styles.templateWrapper}`}>
            <Outlet />
        </Grid >

    )
}
